<div class="relative flex flex-column align-items-center justify-content-center h-12rem w-full border-1 border-500 hover:border-700 border-round-sm cursor-pointer">
  <div class="absolute top-0 left-0 text-xs -translate-y-100 px-1 bg-white mdc-floating-label mdc-floating-label--float-above text-gray-600" style="margin-top: 0.65rem !important; margin-left: 0.65rem !important;">{{label}}</div>
  <app-empty-map *ngIf="!hasCoordinate()" [label]="label" (click)="openSelectMapDialog()"></app-empty-map>
  <div class="p-1 cursor-pointer" *ngIf="hasCoordinate()" style="min-width: 100%; height: 100%;overflow:scroll;">
    <!-- <google-map
      #myMap="googleMap"
      mapId="show-maps"
      [center]="center()"
      [zoom]="zoom"
      [options]="options"
      width="100%"
      height="100%"
      (click)="openSelectMapDialog()"
    >
      <map-advanced-marker *ngIf="hasCoordinate() !== null" [position]="coordinate()!" [title]="'Lat: ' + coordinate()?.lat + ' Lng: ' + coordinate()?.lng + ' alt: ' + coordinate()?.altitude" />
    </google-map> -->
    <app-maps-field [value]="coordinate()"></app-maps-field>
    <div class="absolute top-0 left-0 h-10rem w-20rem cursor-pointer z-5" (click)="openSelectMapDialog()"></div>
  </div>
  <mat-error *ngIf="hasError()" class="text-xs">{{error()}}</mat-error>
  <mat-hint *ngIf="hint" class="text-xs text-600">{{hint}}</mat-hint>
</div>
